// extracted by mini-css-extract-plugin
export var bulkPurchaseTable = "_f-0";